var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleDataCard',{attrs:{"title":'Toplam Bekleyen Sipariş',"data":_vm.numberConverter(_vm.reportCompanyData.totalPendingOrderAmount,'TRY'),"description":'Tüm Zamanlar',"loading":_vm.reportCompanyDataLoading,"route":"pending-order-list"}})
}
var staticRenderFns = []

export { render, staticRenderFns }